export default __webpack_public_path__ + "static/media/uservoice.914079f5.svg";